// Copyright (c) 2026 DMG L&D, LLC. All rights reserved.
// Proprietary and confidential. See LICENSE for terms.

/**
 * URL-decode a percent-encoded string (given as bytes), returned as UTF-8 bytes.
 */

import type { Bytes } from '../types.ts';

export async function urlDecode(input: Bytes): Promise<Bytes> {
  if (!(input instanceof Uint8Array)) {
    throw new Error('url.decode: input must be a Uint8Array');
  }

  const str = new TextDecoder().decode(input);
  if (str.length === 0) {
    return new Uint8Array(0);
  }

  try {
    const decoded = decodeURIComponent(str);
    return new TextEncoder().encode(decoded);
  } catch {
    throw new Error('url.decode: invalid percent-encoded input');
  }
}
